import React, { FC } from 'react';
import { useCommentsSummary } from 'app/modules/posts/modules/post/components/postCommunication/comments/hooks/useCommentsSummary';
import CommentsHyperText from 'app/modules/posts/modules/post/components/postCommunication/comments/commentsList/CommentsHyperText';
import CommentWorkflow from 'app/modules/posts/modules/post/components/postCommunication/comments/commentsList/CommentWorkflow';
import { usePostCommunicationContext } from 'app/modules/posts/modules/post/components/postCommunication/PostCommunicationProvider';
import { useTranslation } from 'react-i18next';
import CommentsListItemBubbleWrapper from 'app/modules/posts/modules/post/components/postCommunication/comments/commentsList/CommentsListItemBubbleWrapper';

type Props = {};

const TEXT_LIMIT = 100;

const CommentsClientActiveApprovalRequest: FC<Props> = (props) => {
  const { scrollToActiveRequestComment } = usePostCommunicationContext();
  const { data } = useCommentsSummary();
  const { t } = useTranslation();

  if (!data?.pendingApprovalRequest) {
    return null;
  }

  const { pendingApprovalRequest } = data;

  return (
    <CommentsListItemBubbleWrapper
      colorVariant="primary"
      innerClassName="tw-max-w-full tw-w-full"
      isCurrent={pendingApprovalRequest.user.its_me}
    >
      <CommentsHyperText
        mentionedUsers={pendingApprovalRequest.mentioned_users ?? []}
        isCurrentUser={pendingApprovalRequest.user.its_me}
        colorVariant="primary"
        options={{ maxLength: TEXT_LIMIT }}
      >
        {pendingApprovalRequest.content}
      </CommentsHyperText>
      {pendingApprovalRequest.content.length > TEXT_LIMIT && (
        <span
          onClick={scrollToActiveRequestComment}
          className="tw-ml-1 tw-cursor-pointer tw-text-primary-100"
        >
          {t('readMore')}
        </span>
      )}
      <CommentWorkflow
        comment={pendingApprovalRequest}
        enableRespondToApprovalRequest
      />
    </CommentsListItemBubbleWrapper>
  );
};

export default CommentsClientActiveApprovalRequest;
